import { render } from "./OrderCanceled.vue?vue&type=template&id=6b157736&bindings={}"
import script from "./OrderCanceled.vue?vue&type=script&lang=js"
export * from "./OrderCanceled.vue?vue&type=script&lang=js"
script.render = render

export default script